@if (current) {
  <div class="page-title">
    @if (showBackButton) {
      <button class="page-title__back" type="button" (click)="goBack()" [attr.aria-label]="'global.back' | translate">
        <i class="agres-return" aria-hidden="true"></i>
      </button>
    }
    <div class="page-title__text">
      @if (parents.length > 0) {
        <p class="page-title__trail">
          @for (crumb of parents; track crumb.url; let last = $last) {
            <span>{{ crumb.label | translate }}</span>
            @if (!last) {
              <span class="page-title__separator" aria-hidden="true">/</span>
            }
          }
        </p>
      }
      <h1 class="page-title__heading">{{ current.label | translate }}</h1>
    </div>
  </div>
}
